import { lazy } from "react";

const DashboardPage = lazy(() => import("./pages/DashboardPage"));

export const dashboardRoutes = [
  {
    index: true,
    element: <DashboardPage />,
    handle: { label: "Home", title: "Home", icon: "house", protected: true },
  },
];
